import React, { Fragment, useEffect, useState } from "react";
import GalaxyCard from "./galaxyCard";
import { ILiftOffHeader } from "../../../../model/interface/subject";
import {
  ILiftOffGalaxyStandardInfo,
  ILiftOffGalaxyTopic,
} from "../../../../model/interface/liftOffGalaxyStandard";
import { getLiftOffGalaxyStandardInfo } from "../../../../api/liftOffGalaxyStandard.service";
import constant from "../../../../utils/constant";
import GalaxyPopup from "./galaxyPopup";
import { toast } from "react-toastify";
import { saveLFDiagnosticTest } from "../../../../api/liftOffDiagnosticTest.service";
import Loader from "../../../shared/loader/loader";
interface GalaxyTabProps extends ILiftOffHeader {
  number?: number;
  handleHeaderNameChange: (header: ILiftOffHeader) => void;
  selectedStates: Array<number>;
  selectedGrades: Array<number>;
  selectedContentId: number;
}

const GalaxyTab = (props: GalaxyTabProps) => {
  const [selectedGalaxyId, setSelectedGalaxyId] = useState(0);
  const [disableAddGalaxy, setDisableAddGalaxy] = useState(false);
  const [lfGalaxyInfo, setLFGalaxyInfo] = useState<
    Array<ILiftOffGalaxyStandardInfo>
  >([]);
  const totalGalaxies = 8;
  const [selectedStandards, setSelectedStandards] = useState<
    Array<ILiftOffGalaxyTopic>
  >([]);
  const [showGalaxyPopup, setShowGalaxyPopup] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    bindData();
  }, [props.liftOffHeaderId]);

  useEffect(() => {
    if (lfGalaxyInfo && lfGalaxyInfo.length > 0) {
      setSelectedGalaxyId(lfGalaxyInfo[0].liftOffGalaxyId);
    }
  }, [lfGalaxyInfo]);

  const getData = async () => {
    const response = await getLiftOffGalaxyStandardInfo(props.liftOffHeaderId);
    const lfGalaxyIds = response.data.map((i) => i.liftOffGalaxyId);
    const maxLFGalaxyId = Math.max(...lfGalaxyIds);
    const lfGalaxydata = response.data;

    if (lfGalaxyIds.length > 0) {
      [...Array(maxLFGalaxyId)].map((item, index) => {
        if (!lfGalaxyIds.includes(index + 1)) {
          const lfGalaxy: ILiftOffGalaxyStandardInfo = {
            liftOffHeaderId: props.liftOffHeaderId,
            liftOffGalaxyId: index + 1,
            standardCount: 0,
            liftOffGalaxyName: "Galaxy " + (index + 1),
          };
          lfGalaxydata.push(lfGalaxy);
        }
      });

      const data = lfGalaxydata.sort((a, b) => {
        return b.liftOffGalaxyId - a.liftOffGalaxyId;
      });
      setLFGalaxyInfo(data);
    } else {
      setLFGalaxyInfo(response.data);
    }
  };

  const bindData = () => {
    setDisableAddGalaxy(false);
    getData();
  };

  const handleGalaxyCardSelection = (lfGalaxyId: number) => {
    setSelectedGalaxyId(lfGalaxyId);
  };

  const handleHeaderNameChange = (name: string) => {
    const header: ILiftOffHeader = {
      ...props,
    };
    header.header = name;
    props.handleHeaderNameChange(header);
  };

  const handleAddNewGalaxy = () => {
    setDisableAddGalaxy(true);

    setLFGalaxyInfo((prev) => {
      const lfGalaxy: ILiftOffGalaxyStandardInfo = {
        liftOffHeaderId: props.liftOffHeaderId,
        liftOffGalaxyId: prev.length + 1,
        standardCount: 0,
        liftOffGalaxyName: "Galaxy " + (prev.length + 1),
      };

      if (prev.length < totalGalaxies && !disableAddGalaxy) {
        const data = [...prev, lfGalaxy].sort((a, b) => {
          return b.liftOffGalaxyId - a.liftOffGalaxyId;
        });
        return data;
      }
      return [...prev];
    });
  };

  const handleAddNewHeirarchy = () => {
    if (selectedStandards.length > 0) {
      setShowGalaxyPopup(true);
    } else {
      toast.info("Please select standards.");
    }
  };

  const handleSaveTest = (data: any) => {
    setLoading(true);
    saveLFDiagnosticTest(data.test, data.questions)
      .then((r) => {
        setLoading(false);
        setShowGalaxyPopup(false);
        toast.success("Successfully saved.");
      })
      .catch((r) => {
        setLoading(false);
        toast.success("Something went wrong.");
      });
  };

  return (
    <Fragment>
      {showGalaxyPopup && (
        <GalaxyPopup
          liftOffHeaderId={props.liftOffHeaderId}
          showPopup={setShowGalaxyPopup}
          selectedStandards={selectedStandards}
          subjectId={props.subjectId}
          testName={""}
          lfDiagTestQuestions={[]}
          saveTest={handleSaveTest}
        />
      )}

      {loading && <Loader />}
      <div className="mt-1 ">
        <div className="flex justify-between items-end">
          <div className="max-w-sm">
            <div className=" text-sm text-gray-700 mb-1 ">Header Name</div>
            <input
              id="username"
              name="username"
              type="input"
              value={props.header}
              onChange={(e) => {
                handleHeaderNameChange(e.target.value);
              }}
              placeholder="Number and place value"
              className="border-gray-300 appearance-none border block w-full px-3 py-2 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
            />
          </div>

          <div className=" ">
            <button
              type="submit"
              className={`mr-3 px-3 py-2 mt-4 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color
        ${disableAddGalaxy ? "opacity-50" : ""}
        `}
              onClick={() => {
                handleAddNewHeirarchy();
              }}
            >
              Add New Heirarchy
            </button>
            <button
              type="submit"
              className={`px-3 py-2 mt-4 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color
        ${disableAddGalaxy ? "opacity-50" : ""}
        `}
              onClick={() => {
                handleAddNewGalaxy();
              }}
            >
              Add New Galaxy
            </button>
          </div>
        </div>
      </div>

      {lfGalaxyInfo.map((item, index) => (
        <GalaxyCard
          key={index}
          liftOffGalaxyName={item.liftOffGalaxyName}
          liftOffGalaxyId={item.liftOffGalaxyId}
          liftOffHeaderId={props.liftOffHeaderId}
          isLastGalaxyCard={item.liftOffGalaxyId == lfGalaxyInfo.length}
          isGalaxyCardSelected={true}
          setDisableAddGalaxy={setDisableAddGalaxy}
          onClicked={(lfGalaxyId) => {
            handleGalaxyCardSelection(lfGalaxyId);
          }}
          setSelectedStandards={setSelectedStandards}
          selectedStandards={selectedStandards}
          selectedStates={props.selectedStates}
          selectedGrades={props.selectedGrades}
          selectedContentId={props.selectedContentId}
          testId={0}
          subjectId={props.subjectId}
        />
      ))}
    </Fragment>
  );
};

export default GalaxyTab;
